import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en.json";
import hi from "./hi.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "hi"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "hisabx_lang",
    },
  });

// If user previously selected a language we no longer ship (mr/gu/bn/ta),
// migrate their preference to English so they don't see fallback strings.
if (typeof localStorage !== "undefined") {
  const stored = localStorage.getItem("hisabx_lang");
  if (stored && !["en", "hi"].includes(stored.split("-")[0])) {
    localStorage.setItem("hisabx_lang", "en");
    i18n.changeLanguage("en");
  }
}

// Keep <html lang> in sync for a11y / SEO / screen readers
if (typeof document !== "undefined") {
  const applyLang = (lng) => {
    const code = (lng || "en").split("-")[0];
    document.documentElement.setAttribute("lang", code);
  };
  applyLang(i18n.language);
  i18n.on("languageChanged", applyLang);
}

export default i18n;
